
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[propertyId]/reservenow",
      function () {
        return require("private-next-pages/[propertyId]/reservenow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[propertyId]/reservenow"])
      });
    }
  